import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, Grid, Switch, Typography } from "@mui/material"
import PaperBox from "components/PaperBox"
import { StyledFormControlLabel, StyledPrimaryUserAvatar } from "shared/styled/Global"

const VtrSwitch = (props) => {
  const { title, message, icon, img, value, handleChange, id } = props

  return (
    <PaperBox marginBottom={2} mt={0}>
      <Grid container direction="row" justifyContent="space-between" alignItems="center">
        {img || icon ? (
          <Grid item xs={2}>
            <Box>
              <StyledPrimaryUserAvatar aria-label={title}>
                {img && <img height="18px" width="18px" src={img} alt={title} />}
                {icon && icon && <FontAwesomeIcon icon={icon} size="lg" />}
              </StyledPrimaryUserAvatar>
            </Box>
          </Grid>
        ) : null}

        <Grid item xs={8}>
          <Typography variant="h5">{title}</Typography>
          <Typography variant="bodySmall">{message}</Typography>
        </Grid>
        <Grid item xs={2}>
          <StyledFormControlLabel control={<Switch checked={value} onChange={handleChange} id={id} />} />
        </Grid>
      </Grid>
    </PaperBox>
  )
}

export default VtrSwitch
